import axios from "axios";
import { API_URL } from "../constant/Constant";

class BankService {
  checkBankDetailsSubmitted(encryptedCreditCheckId, encryptedUserId, flag) {
    return axios.get(
      `${API_URL}api/bankDetails/check/${encryptedCreditCheckId}/${encryptedUserId}/${flag}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  }

  checkLinkValidity(encryptedCreditCheckId, encryptedUserId) {
    return axios.get(
      `${API_URL}api/bankDetails/validity/${encryptedCreditCheckId}/${encryptedUserId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  }

  submitBankDetails(bankDetails) {
    return axios.post(`${API_URL}api/bankDetails/submitBankDetails`, bankDetails, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }).then(response => {
      // Create a sanitized response without sensitive data
      const { bicCode, ibanNumber, ...sanitizedResponse } = response.data;
      return {
        ...response,
        data: sanitizedResponse
      };
    });
  }
}

export default new BankService();
